enum EMobileLayoutActiveSide {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

type TMobileLayoutActiveSideState =
  | EMobileLayoutActiveSide.Left
  | EMobileLayoutActiveSide.Right
  | EMobileLayoutActiveSide.Center;

export { EMobileLayoutActiveSide, TMobileLayoutActiveSideState };
